import { render, staticRenderFns } from "./PcPageLoading.vue?vue&type=template&id=66c4b550&scoped=true"
import script from "./PcPageLoading.vue?vue&type=script&lang=ts"
export * from "./PcPageLoading.vue?vue&type=script&lang=ts"
import style0 from "./PcPageLoading.vue?vue&type=style&index=0&id=66c4b550&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c4b550",
  null
  
)

export default component.exports